import ThemeToggle from "./components/ThemeToggle.jsx";
import AnalyticsConsent from "./components/AnalyticsConsent.jsx";
import AccessGate from "./components/AccessGate.jsx";
import routes from "./data/route-index.json";
import { integrationConfig, isProductionHost } from "./lib/integrations.js";

const modules = import.meta.glob("./pages/**/*.jsx");
export function normalizePath(pathname) {
  let result =
    decodeURI(pathname)
      .replace(/\.html$/, "")
      .replace(/\/$/, "") || "/";
  return result === "/index" ? "/" : result;
}
export function findRoute(pathname) {
  return routes.find((route) => route.route === normalizePath(pathname));
}
export async function resolvePage(pathname) {
  const route = findRoute(pathname);
  const load =
    route && modules[`./pages/${route.file.replace(/\.html$/, ".jsx")}`];
  return load ? (await load()).default : null;
}
export default function App({ Page = null }) {
  return (
    <>
      {Page ? (
        <Page />
      ) : (
        <main className="contentPage">
          <article className="contentHero shell">
            <h1>Page introuvable</h1>
            <a href="/fr">Revenir à NovaVP</a>
          </article>
        </main>
      )}
      <ThemeToggle />
      <AnalyticsConsent />
      {integrationConfig.accessGate && isProductionHost() && <AccessGate />}
    </>
  );
}
